export type Currency = 'PHP';

export interface Money {
  minor: number;
  currency: Currency;
}

export const peso = (minor: number): Money => ({ minor, currency: 'PHP' });

/**
 * Formats centavos as pesos: 123450 -> '₱1,234.50'.
 * cents 'auto' (default) drops '.00' on whole amounts: 123400 -> '₱1,234'.
 * cents 'always' keeps it: 123400 -> '₱1,234.00'.
 * Uses integer math, not Intl, so the output is identical on every device.
 */
export function formatPeso(minor: number, opts: { cents?: 'always' | 'auto' } = {}): string {
  if (!Number.isSafeInteger(minor)) {
    throw new RangeError(`formatPeso expects integer minor units, got ${minor}`);
  }
  const cents = opts.cents ?? 'auto';
  const sign = minor < 0 ? '-' : '';
  const abs = Math.abs(minor);
  const whole = Math.floor(abs / 100);
  const frac = abs % 100;
  const wholeText = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const fracText = cents === 'auto' && frac === 0 ? '' : `.${String(frac).padStart(2, '0')}`;
  return `${sign}₱${wholeText}${fracText}`;
}
